(function() { window.GUID_3ab62cbf_95c0_4057_a54f_94241a7aa397 = { getGuid: function() { return "3ab62cbf-95c0-4057-a54f-94241a7aa397"; } }; })();
var CS;
(function (CS) {
    class Page {
        constructor() {
            this.OnPageInstantiated();
        }
    }
    CS.Page = Page;
})(CS || (CS = {}));

//# sourceMappingURL=page.js.map
